<template>
  <div class="password-reset">
    <h1 class="password-reset__title">{{ $t("views.password.reset.reset_password") }}</h1>

    <b-alert v-if="error" variant="danger" show>
      {{ $t("views.password.reset.reset_response_error") }}
    </b-alert>

    <p>{{ $t("views.password.reset.instructions") }}</p>

    <b-form class="password-reset__form" novalidate @submit.prevent="passwordReset">
      <b-form-group :label="$t('views.password.reset.email')">
        <b-form-input type="email" disabled :value="email" />
      </b-form-group>

      <forms-validated-input
        v-model="newPassword"
        mode="lazy"
        name="new_password"
        :label="$t('views.password.reset.new_password')"
        :rules="{ required: true, min: 8 }"
        type="password"
        :placeholder="$t('views.password.reset.new_password')"
        :description="$t('views.password.reset.new_password_length')"
      />

      <forms-validated-input
        v-model="newPasswordRepeat"
        mode="lazy"
        name="new_password_repeat"
        :label="$t('views.password.reset.new_password_repeat')"
        :rules="{ required: true, is: newPassword }"
        type="password"
        :placeholder="$t('views.password.reset.new_password_repeat')"
      />

      <b-form-group>
        <icon-button type="submit" :loading="loading" variant="success" block>
          {{ $t("views.password.reset.submit") }}
        </icon-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import IconButton from "@/components/shared/IconButton.vue";
import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";

export default {
  name: "PasswordReset",
  components: { IconButton, FormsValidatedInput },
  data() {
    return {
      error: false,
      loading: false,
      newPassword: "",
      newPasswordRepeat: "",
    };
  },
  computed: {
    email() {
      if (!this.$route.query) {
        return null;
      }

      return this.$route.query.email;
    },
    token() {
      if (!this.$route.query) {
        return null;
      }

      return this.$route.query.token;
    },
  },
  methods: {
    async passwordReset() {
      this.loading = true;
      this.error = false;

      const { email, token, newPassword, newPasswordRepeat } = this;

      try {
        await this.$store.dispatch("password/reset", {
          email,
          newPassword,
          newPasswordRepeat,
          token,
        });

        this.$store.commit("addNotification", {
          content: this.$t("views.password.reset.notifications.message"),
          title: this.$t("views.password.reset.notifications.title"),
          variant: "success",
          type: "password",
        });

        this.$router.push("/login").catch(() => {});
      } catch (e) {
        this.error = true;
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.password-reset {
  .password-reset__form {
    margin-top: 32px;
  }

  .password-reset__title {
    text-align: center;
    color: $black;
    font-size: 24px;
    margin-bottom: 20px;
  }
}
</style>
